import { memo } from "react";
import { PayrollRecordView } from "./PayrollRecordView";
import { PayrollActionLinks } from "./PayrollActionLinks";

export const PayrollAggregationRecordView = memo(() => {
  return (
    <PayrollRecordView
      className="mb-4"
      actions={[
        <PayrollActionLinks
          aggregateOptions={{ isBold: true, isDisabled: true }}
        />,
      ]}
    />
  );
});
